import React from 'react';

import NumberFormat from 'react-number-format';

import { separators } from 'Helpers/currencyFormat';

/**
 * react-number-format pre-configured with the separators of the currency in
 * scope, so a formatted input reads the same way as every figure beside it.
 *
 * Drop-in for `react-number-format`: `thousandSeparator={true}` resolves to the
 * currency's group separator instead of a hardcoded comma, and the decimal
 * separator follows too. Everything else is passed straight through, so
 * existing usages need only change their import.
 *
 * Keeping both separators in one place is the point — the handler that reads
 * these fields parses with the same pair, and if the two ever disagreed the
 * value would be stored with the wrong magnitude.
 */
export default function LocalisedNumberFormat({ thousandSeparator, decimalSeparator, ...props }) {
    const { group, decimal } = separators();

    return (
        <NumberFormat
            {...props}
            thousandSeparator={thousandSeparator === true ? group : thousandSeparator}
            decimalSeparator={decimalSeparator === undefined ? decimal : decimalSeparator}
        />
    );
}
